import {
  ApplicantFlowStepsNames,
  ApplicantFlowStepName,
  ApplicantFlowStepsMap,
  StepData,
} from 'src/features/applicant-flow/types';
import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { ApplicantFlowModel, FlowModel } from './models';

export function getApplicantFlowsEndpoint() {
  return '/applicants';
}

function fetchApplicantFlowsService(client: ApiClient = apiClient) {
  return client.get<FlowModel[]>(getApplicantFlowsEndpoint());
}

export function fetchApplicantFlowService(
  client: ApiClient = apiClient,
): Promise<FlowModel | undefined> {
  return fetchApplicantFlowsService(client).then((flows) => flows.at(-1));
}

export function createApplicantFlowService(
  flowData: ApplicantFlowModel,
  client: ApiClient = apiClient,
) {
  return client.post<FlowModel>('/applicants', flowData);
}

const ApplicantFlowStepsKeys: ApplicantFlowStepsMap<string> = {
  [ApplicantFlowStepsNames.CreditCheck]: 'credit-check',
  [ApplicantFlowStepsNames.EmploymentInformation]: 'employment-information',
  [ApplicantFlowStepsNames.IncomeVerification]: 'income-verification',
  [ApplicantFlowStepsNames.ReferenceCheck]: 'reference-check',
  [ApplicantFlowStepsNames.BackgroundCheck]: 'background-check',
  [ApplicantFlowStepsNames.ApplicationFee]: 'application-fee',
  [ApplicantFlowStepsNames.IdVerification]: 'id-verification',
};

export const getApplicantsFlowStepEndpoint = (
  flowId: string,
  stepName: ApplicantFlowStepName,
  stepId: string,
) => `/applicants/${flowId}/${ApplicantFlowStepsKeys[stepName]}/${stepId}`;

export function fetchApplicantFlowStepService<
  TStepName extends ApplicantFlowStepName,
>(
  flowId: string,
  stepName: TStepName,
  stepId: string,
  client: ApiClient = apiClient,
) {
  return client.get<StepData<TStepName>['get']>(
    getApplicantsFlowStepEndpoint(flowId, stepName, stepId),
  );
}

export function updateApplicantFlowStepService<
  TStepName extends ApplicantFlowStepName,
  TStepData extends StepData<TStepName>['put'],
>(
  flowId: string,
  stepName: TStepName,
  stepId: string,
  stepData: TStepData,
  client: ApiClient = apiClient,
) {
  return client.put<StepData<TStepName>['get']>(
    getApplicantsFlowStepEndpoint(flowId, stepName, stepId),
    stepData,
  );
}
